// extracted by mini-css-extract-plugin
export var actionIcon = "_p6-0";